import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getModesConfig} from 'helpers/modes-config';
import {calcPlayerExposure} from 'components/organisms/used-players-list/helpers';

class PlayerExposureSummary extends Component {
    getPlayerDependOnLineupRole(playerId, lineupRole) {
        const {players} = this.props;

        for (let player of players.all()) {
            if (player.getId() === playerId && player.lineupRole === lineupRole) {
                return {...player};
            }
        }

        return null;
    }

    calcPlayerExposure(player) {
        const {filterLineupsByPlayer, lineups} = this.props;

        return calcPlayerExposure(player.usedLineupsCount, filterLineupsByPlayer, lineups);
    }

    canPlayerModeExposureBeRendered(player) {
        if (player === null) {
            return false;
        }

        const {filters} = this.props;

        return player.usedLineupsCount > 0 || filters.isShowUnexposedPlayersEnabled();
    }

    render() {
        const {playerId} = this.props;

        return (
            <div>
                {Object.values(getModesConfig(this.props)).map((mode, i) => {
                    const player = this.getPlayerDependOnLineupRole(playerId, mode.getRole());
                    if (this.canPlayerModeExposureBeRendered(player)) {
                        return (
                            <label className="inline-text" key={i}>
                                {`${mode.getLabel()} - ${this.calcPlayerExposure(player)}%(${player.usedLineupsCount})`}
                            </label>
                        );
                    }
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers: {players, filters},
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;

    return {
        players,
        filterLineupsByPlayer,
        lineups,
        filters,
    };
}

export default connect(mapStatesToProps)(PlayerExposureSummary);

export {PlayerExposureSummary};
